import request from "@/utils/request";

export const  bookList =(accountId) =>{
    return request({
        url: "/adminservice/book/list",
        method:"get",
    })
}

// 查询字典基础数据
// 分层作业学段学科：hierarchy_homework
export const  queryDict =(query) =>{
    return request({
        url: "/businessservice/basicdata/queryDict",
        method:"get",
        params: query
    })
}

export function download(url, fileName) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.setAttribute('target', '_blank');
    fileName && a.setAttribute('download', fileName);
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
/*直接下载，不预览*/
export function downloadFile(url, fileName) {
    if (!url) return;
    // https页面下http资源会被浏览器拦截（<img>会自动升级为https，但XHR不会），
    // 统一升级为https，避免XHR失败兜底为URL直链下载导致文件名变成OSS对象名
    if (window.location.protocol === 'https:' && /^http:\/\//i.test(url)) {
        url = url.replace(/^http:\/\//i, 'https://');
    }
    // 图片经<img>预览时响应已被浏览器缓存，而OSS对不带Origin的请求不返回CORS头、响应也没有Vary:Origin，
    // XHR(带Origin)命中该缓存会因缺CORS头校验失败，兜底为URL直链下载导致文件名变成OSS对象名。
    // 追加时间戳参数使XHR绕过该缓存项（OSS会忽略未知参数；签名URL加参数会破坏签名，跳过）
    if (!/[?&](OSSAccessKeyId|Signature|Expires|security-token)=/i.test(url)) {
        url += (url.indexOf('?') >= 0 ? '&' : '?') + '_t=' + Date.now();
    }
    const x = new window.XMLHttpRequest();
    x.open('GET', url, true);
    x.responseType = 'blob';
    x.onload = () => {
        // 请求失败（如跨域被拦截、404）时回退为新窗口打开地址，避免无任何响应
        if (x.status === 200 && x.response) {
            const blobUrl = window.URL.createObjectURL(x.response);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
        } else {
            download(url, fileName);
        }
    };
    // 跨域等网络错误时onload不会触发，回退为新窗口打开地址
    x.onerror = () => {
        download(url, fileName);
    };
    x.send();
}
